import vi from 'vuetify/lib/locale/vi'
export default {
  ...vi,
  msg: {
    getFileSampe: "Lấy file mẫu (nếu chưa có), sau đó chuẩn bị dữ liệu trước khi import.",
    hasError: "Đã xảy ra lỗi, Vui lòng thử lại.",
    hasWarning: "Vui lòng kiểm tra lại thông tin.",
    getSuccess: "Thao tác thành công."
  },
  title: {

  }
}